import { apiFieldMessages, apiMessage } from '@/lib/contacts/errors'

export function accountingErrorMessage(error: Error) {
  return (
    apiFieldMessages(error, 'revenue_destination')[0] ??
    apiFieldMessages(error, 'revenue_destinations')[0] ??
    apiFieldMessages(error, 'deposit_account')[0] ??
    apiFieldMessages(error, 'deposit_accounts')[0] ??
    apiFieldMessages(error, 'payment_type')[0] ??
    apiFieldMessages(error, 'authorization')[0] ??
    apiFieldMessages(error, 'connection')[0] ??
    apiMessage(error)
  )
}
